"use client";

import dynamic from "next/dynamic";

export const LazyChatBotModal = dynamic(
  () => import("./chat-bot-modal").then((module) => module.ChatBotModal),
  { ssr: false }
);
